import { css } from 'linaria';

export const bannerContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  padding: 0 24px;

  @media (--only-tablet) {
    flex-direction: column;
    align-items: flex-start;
    padding: 22px 24px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    align-items: flex-start;
    flex-grow: unset;
    width: 213px;
    padding: 24px 32px 24px 16px;
  }
`;
